/** Textos do fluxo de verificação de integração WhatsApp (mensagem de teste) nas configurações. */

/** Parágrafo introdutório da secção «Testar envio». */
export const REMINDER_WHATSAPP_TEST_SECTION_INTRO =
  'Envie uma mensagem de teste para o número cadastrado abaixo. Quando o WhatsApp confirmar o recebimento, liberamos o restante do app automaticamente. Enquanto o teste não for confirmado, você pode tentar de novo (sem limite de tentativas).';

export const REMINDER_WHATSAPP_TEST_PHONE_LABEL = 'Número que receberá o teste';

export const REMINDER_WHATSAPP_TEST_PHONE_UNDEFINED = 'Número não definido';

export const REMINDER_WHATSAPP_TEST_PHONE_CHANGE_PREFIX =
  'É neste número que validamos a integração com o WhatsApp. Para alterar o celular, acesse';

export const REMINDER_WHATSAPP_TEST_PHONE_CHANGE_LINK = 'Minha conta';

export const REMINDER_WHATSAPP_TEST_PHONE_CHANGE_SUFFIX = ' a qualquer momento.';

export const REMINDER_WHATSAPP_TEST_INTEGRATION_NOTICE =
  'Para utilizar o app corretamente, precisamos que verifique a integração do seu número com o WhatsApp. Clique em enviar mensagem de teste.';

export const REMINDER_WHATSAPP_TEST_INTEGRATION_VERIFIED =
  'Integração com o WhatsApp verificada. Se você alterar o número de celular, será necessário enviar uma nova mensagem de teste.';

export const REMINDER_WHATSAPP_TEST_SENDING_ONSCREEN = 'Enviando mensagem de teste…';

/** Após o envio à API: aguardamos o Firestore refletir a confirmação (webhook / doc). */
export const REMINDER_WHATSAPP_TEST_AWAITING_CONFIRMATION =
  'Aguardando confirmação do WhatsApp. Quando o servidor registrar o recebimento, liberamos o restante do app automaticamente.';

export const REMINDER_WHATSAPP_TEST_RESEND_COUNTDOWN = (seconds: number): string =>
  `Você poderá enviar outro teste em ${seconds}s.`;

export const REMINDER_WHATSAPP_TEST_SENT_ONSCREEN =
  'Mensagem de teste enviada. Confira seu WhatsApp. Assim que confirmar o recebimento, a integração será marcada como verificada.';

export const REMINDER_SETTINGS_FOOTER_DOUBTS_INTRO = 'Dúvidas?';

export const REMINDER_SETTINGS_FOOTER_FAQ_SUPPORT_LINK = 'Acesse o FAQ e Suporte';
